export default "__VITE_PUBLIC_ASSET__6ea01661__"